import { Component, OnInit, trigger, state, style, transition, animate, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'cm-info-legende',

    template: `
        <div class="ecran-info-legende text-justify" 
            [@afficherCacherEcran]="etatEcran">

            <div class="cadre-fermer" (click)="fermer()"> <img class="img image-fermer" src="./assets/images/croix.png"/> </div>

            <div class="cadre-defilement">
                <h3>Légende</h3>

                <hr>

                <h4>Types de sanctuaires</h4>

                <div class="cadre-sanctuaire row">
                    <div class="image-sanctuaire"><img class="img img-responsive" src="./assets/images/icon_sanctuary_main.png"></div>
                    <div class="texte-sanctuaire">Principaux sanctuaires</div>
                </div>
                <div class="cadre-sanctuaire row">
                    <div class="image-sanctuaire"><img class="img img-responsive" src="./assets/images/icon_sanctuary.png"></div>
                    <div class="texte-sanctuaire">Sanctuaires</div>
                </div>
                <div class="cadre-sanctuaire row">
                    <div class="image-sanctuaire"><img class="img img-responsive" src="./assets/images/icon_cathedral.png"></div>
                    <div class="texte-sanctuaire">Cathédrales</div>
                </div>
                <div class="cadre-sanctuaire row">
                    <div class="image-sanctuaire"><img class="img img-responsive" src="./assets/images/icon_basilica.png"></div>
                    <div class="texte-sanctuaire">Basiliques</div>
                </div>
                <div class="cadre-sanctuaire row">
                    <div class="image-sanctuaire"><img class="img img-responsive" src="./assets/images/icon_church.png"></div>
                    <div class="texte-sanctuaire">Église</div>
                </div>
                <div class="cadre-sanctuaire row">
                    <div class="image-sanctuaire"><img class="img img-responsive" src="./assets/images/icon_chapel.png"></div>
                    <div class="texte-sanctuaire">Chapelles</div>
                </div>
                <div class="cadre-sanctuaire row">
                    <div class="image-sanctuaire"><img class="img img-responsive" src="./assets/images/icon_oratory.png"></div>
                    <div class="texte-sanctuaire">Oratoires</div>
                </div>
                <div class="cadre-sanctuaire row">
                    <div class="image-sanctuaire"><img class="img img-responsive" src="./assets/images/icon_other.png"></div>
                    <div class="texte-sanctuaire">Autres</div>
                </div>

                <h4>Indications particulières</h4>

                <div class="cadre-sanctuaire row">
                    <div class=""><img class="img img-responsive image-sanctuaire" src="./assets/images/icon_apparition.png"></div>
                    <div class="texte-sanctuaire">Lieux d'apparitions</div>
                </div>
                <div class="cadre-sanctuaire row">
                    <div class=""><img class="img img-responsive image-sanctuaire" src="./assets/images/icon_commemoration.png"></div>
                    <div class="texte-sanctuaire">Lieux de commémoration</div>
                </div>
                <div class="cadre-sanctuaire row">
                    <div class=""><img class="img img-responsive image-sanctuaire" src="./assets/images/icon_miracle.png"></div>
                    <div class="texte-sanctuaire">Miracles</div>
                </div>
                <div class="cadre-sanctuaire row">
                    <div class=""><img class="img img-responsive image-sanctuaire" src="./assets/images/icon_pilgrimage.png"></div>
                    <div class="texte-sanctuaire">Pélérinage</div>
                </div>
                <div class="cadre-sanctuaire row">
                    <div class=""><img class="img img-responsive image-sanctuaire" src="./assets/images/icon_message.png"></div>
                    <div class="texte-sanctuaire">Messages</div>
                </div>

            </div>

        </div>
    `,

    styles: [`
        .ecran-info-legende {
            position: absolute;
            top: 0;
            left: 60vw;
            width: calc(40vw - 60px);
            height: calc(100vh - 50px);
            background-color: white;
            border: 1px solid lightgray;
        }
        .cadre-defilement {
            padding: 30px 30px 30px 45px;
            height: calc(100vh - 50px - 50px);
            overflow-y: auto;
        }
        .cadre-fermer {
            height: 50px;
        }
        .image-fermer {
            position: relative;
            top: 10px;
            left: calc(100% - 40px);
            width: 25px;
            height: 25px;
            cursor: pointer;
        }
        h3 {
            margin: 0 0 40px 0;
        }
        h4 {
            margin-top: 40px;
            margin-bottom: 15px;
            font-weight: 700;
        }
        .cadre-sanctuaire {
            display: flex;
            padding-top: 6px;
        }
        .image-sanctuaire {
            margin-left: 30px;
            width: 30px;
        }
        .texte-sanctuaire {
            position: relative;
            top: 6px;
            left: 0;
            font-size: 18px;
            margin-left: 20px;
        }

        @media (max-width: 800px), (max-height: 700px) { 
            .ecran-info-legende {
                left: 0;
                width: 100vw;
                height: 100vh;
                padding: 30px 20px 30px 20px;
            }
        }
    `],

     animations: [
        trigger('afficherCacherEcran', [
        state('visible', style({
        transform: 'translateX(0) scale(1, 1)'
        })),
        state('invisible', style({
            transform: 'translateX(100%) scale(0, 1)'
        })),
        transition('visible => invisible', animate('400ms ease-in-out')),
        transition('invisible => visible', animate('400ms ease-in-out'))
        ]),
    ]
})

export class InfoLegendeComponent implements OnInit {
    @Input() etatEcran: string;
    @Output() fermerEcran: EventEmitter<any> = new EventEmitter();

    constructor() {}

    ngOnInit() {
    }

    fermer() {
        this.fermerEcran.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/info-legende.component.ts